import {useEffect} from 'react'

export function useInterval(callback, delay) {
  useEffect(() => {
    const id = setInterval(callback, delay)
    return () => { clearInterval(id) }
  })
}

